export const OPTION_TO_SCHEDULE = 'schedule'
export const OPTION_TO_UNSCHEDULE = 'unschedule'
